export default __webpack_public_path__ + "static/hbdlogo-f65a3898d317807be1206ef0cba90324.png";